const buildFilterQueries = (tags, chans, statuses, teamsAndAgents) => {
  const buildTagsQuery = () => {
    return tags.length ? `tags=${tags.join('&tags=')}` : '';
  };

  const buildChannelsQuery = () => {
    return chans.length ? `channels=${chans.join('&channels=')}` : '';
  };

  const buildStatusesQuery = () => {
    return statuses.length ? `status=${statuses.join('&status=')}` : '';
  };

  const buildAgentsAndTeamsQuery = () => {
    const convertedValues = teamsAndAgents.map((item) => {
      const [type, id] = item.split('_');
      return `${type}s=${id}`;
    });
    return convertedValues.join('&');
  };

  const query = [];
  if (buildTagsQuery()) query.push(buildTagsQuery());
  if (buildChannelsQuery()) query.push(buildChannelsQuery());
  if (buildStatusesQuery()) query.push(buildStatusesQuery());
  if (buildAgentsAndTeamsQuery()) query.push(buildAgentsAndTeamsQuery());
  return query.join('&');
};

export default buildFilterQueries;
